import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { FormattedDate, FormattedAmount } from "vino/core";
import { cancelOrder } from "store/vino/orderSlice";
import OrderItemList from "./OrderItemList";
import TrackPackageDialog from "./TrackPackageDialog";
import { findTracking } from "store/vino/trackingSlice";


function OrdersListItem({ order }) {
	const openTrackingDialog = useSelector(({ vino }) => vino.tracking.openTrackingDialog);
	const dispatch = useDispatch();
	const item = {
		hidden: {
			opacity: 0,
			y: 20,
		},
		show: {
			opacity: 1,
			y: 0,
		},
	};

	const handleOpenTracking = () => {
		dispatch(findTracking(order))		
	};


	const handleCancel = () => {
		dispatch(cancelOrder({ id: order.id, reason: "" }));
	};

	return (
		<>
		<motion.div variants={item} className="w-full pb-24">
			<Card className="flex flex-col shadow">
				<div className="flex flex-shrink-0 items-center justify-between px-24 py-10">
					<div>
						<Typography className="todo-title">
							<span>ORDER PLACED</span>
						</Typography>
						<FormattedDate
							value={order.createdAt}
							className="text-sm text-inherit"
							color="textSecondary"
						/>
					</div>
					<div className="px-32">
						<Typography className="todo-title">
							<span>TOTAL</span>
						</Typography>
						<Typography className="text-sm text-inherit" color="textSecondary">
							<FormattedAmount value={order.totalPrice} />
						</Typography>
					</div>
					<div className="flex flex-1 flex-col relative overflow-hidden px-20">
						<Typography className="todo-title">
							<span>SHIP TO</span>
						</Typography>
						<Typography className="text-sm text-inherit" color="textSecondary">
							{order.shippingAddress.firstName}
							<span className="ml-2">{order.shippingAddress.lastName}</span>
						</Typography>
					</div>
					<div>
						<Typography className="todo-title">
							<span>ORDER # {order.orderNumber}</span>
						</Typography>
						{/* <Link
										to="/"
										className="text-sm text-inherit"
										color="textSecondary"
									>
										View order details
									</Link> */}
					</div>
				</div>
				<Divider />
				<CardContent className="flex flex-col w-full">
					{order.cancelledAt && (
						<div className="w-full flex">
							<Typography className="font-bold">Cancelled</Typography>
							<div className="ml-3">
								<FormattedDate
									value={order.cancelledAt}
									className="font-bold"
								/>
							</div>
						</div>
					)}

					<div className="flex justify-between">
						<div className="w-full">
							<OrderItemList items={order.orderItems.nodes} />
						</div>
						{!order.cancelledAt && (
							<div className="flex flex-col justify-center">
								<Button variant="contained" className="w-200" onClick={handleOpenTracking}>
									Track Package
								</Button>

								<div className="mt-10">
									<Button
										variant="outlined"
										color="warning"
										className="w-200"
										onClick={handleCancel}
										disabled={order.isCancelling}
									>
										{order.isCancelling && (
											<CircularProgress
												className="mr-3"
												color="warning"
												size={20}
											/>
										)}
										Request Cancellation
									</Button>
								</div>
							</div>
						)}
					</div>
				</CardContent>
				<Divider />
			</Card>
		</motion.div>
		{openTrackingDialog &&
			<TrackPackageDialog  />
		}
		</>
	);
}
export default OrdersListItem;
